import React from 'react';
import { connect } from 'react-redux';
import { Steps } from '../../ui/Steps/Steps';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import { selectConfigOnboardingStep } from '../../../redux/config/selectors';
import { OnboardingProgressStepsWrapper } from '../../ui/Layout/OnboardingLayout';

const ITEMS_PART1 = [
  { title: 'Unternehmen' },
  { title: 'Marke' },
  { title: 'Nutzer' },
  { title: 'Bedingungen' },
  { title: 'Abschluss' }
];

const ITEMS_PART2 = [
  { title: 'Bestand' },
  { title: 'Unternehmen' },
  { title: 'Benachrichtigungen' },
  { title: 'Stammdaten' },
  { title: 'Import' },
  { title: 'Nutzer' },
  { title: 'Abschluss' }
];

const STEP_PROGRESS = {
  [ONBOARDING_STEPS.INITIAL]: { index: -1, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.OVERVIEW_ORGANIZATION]: { index: -1, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.ORG_CREATE]: { index: 0, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.ORG_EDIT]: { index: 0, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.APPEARANCE]: { index: 1, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.USERS]: { index: 2, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.DOCUMENTS]: { index: 3, items: ITEMS_PART1 },
  [ONBOARDING_STEPS.ORG_SUCCESS]: { index: 4, items: ITEMS_PART1 },

  [ONBOARDING_STEPS.OVERVIEW_HOUSING_STOCK]: { index: -1, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.HOUSING_STOCK]: { index: 0, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.PARTNERS]: { index: 1, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.NOTIFICATIONS]: { index: 2, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.DATA_SOURCE_SELECT]: { index: 3, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.API_INFO]: { index: 4, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.IMPORT_UPLOAD]: { index: 4, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.PARTNER_USERS]: { index: 5, items: ITEMS_PART2 },
  [ONBOARDING_STEPS.HOUSING_STOCK_SUCCESS]: { index: 6, items: ITEMS_PART2 }
};

const OnboardingProgressComponent = ({ onboardingStep }) => {
  const progress = STEP_PROGRESS[onboardingStep];

  // hide progress for initial step and overview steps
  if (!progress || progress.index < 0) {
    return null;
  }

  return (
    <OnboardingProgressStepsWrapper>
      <Steps current={progress.index} items={progress.items} type="dot" />
    </OnboardingProgressStepsWrapper>
  );
};

const mapStateToProps = (state) => ({
  onboardingStep: selectConfigOnboardingStep(state)
});

export const OnboardingProgress = connect(mapStateToProps)(OnboardingProgressComponent);
